// CategorySkeleton.tsx
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Make sure to import the skeleton CSS
import { useScreen } from "@danishagro/shared/src/contexts/screen.context";
import S from "./CategorySkeltons.module.scss";

export const CategorySkeleton = () => {
    const { isMobileOrTablet } = useScreen();
    return (
        <div className={S.container}>
            {/* LEFT MENU SKELETON */}
            <div className={S.menuWrapper}>
                {/* Category heading */}
                <Skeleton height={30} width={150} />

                {/* Category links */}
                <div className={S.menuItems}>
                    {Array.from({ length: 4 }).map((_, i) => (
                        <Skeleton key={i} height={15} width="80%" />
                    ))}
                </div>

                {/* Filter heading */}
                <Skeleton
                    height={25}
                    width={100}
                    style={{ marginTop: "15px", marginBottom: "15px" }}
                />

                {/* Filter options */}
                <div className={S.filterMenu}>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <Skeleton key={i} height={15} width="70%" />
                    ))}
                </div>

                {/* Filter heading */}
                <Skeleton
                    height={25}
                    width={100}
                    style={{ marginTop: "15px", marginBottom: "15px" }}
                />

                {/* Filter options */}
                <div className={S.filterMenu}>
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Skeleton key={i} height={15} width="70%" />
                    ))}
                </div>

                {/* Filter heading */}
                <Skeleton
                    height={25}
                    width={100}
                    style={{ marginTop: "15px", marginBottom: "15px" }}
                />

                {/* Filter options */}
                <div className={S.filterMenu}>
                    {Array.from({ length: 4 }).map((_, i) => (
                        <Skeleton key={i} height={15} width="70%" />
                    ))}
                </div>
            </div>

            {/* RIGHT SIDE RESULTS SKELETON */}
            <div className={S.resultsWrapper}>
                {/* Top bar: "Resultater: 9 produkter" + sort dropdown */}
                <div className={S.topBar}>
                    {isMobileOrTablet ? (
                        <>
                            <Skeleton height={15} width={50} />
                            <Skeleton height={15} width={50} />
                            <Skeleton height={15} width={50} />
                            <Skeleton height={15} width={50} />
                            <Skeleton height={15} width={50} />
                        </>
                    ) : (
                        <Skeleton height={30} width={120} />
                    )}
                </div>

                {/* Product cards grid */}
                <div className={S.grid}>
                    {Array.from({ length: 12 }).map((_, i) => (
                        <div className={S.card} key={i}>
                            <Skeleton height={isMobileOrTablet ? 140 : 250} className={S.image} />
                            <Skeleton height={10} className={S.title} />
                            <Skeleton className={S.subtitle} />
                            <Skeleton width={75} className={S.price} />
                            <div className={S.bottomBuy}>
                                <div className={S.icons}>
                                    <Skeleton width={24} height={24} />
                                    <Skeleton width={50} height={24} />
                                    <Skeleton width={24} height={24} />
                                </div>
                                <div className={S.buyBtn}>
                                    <Skeleton width={70} height={24} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
